import React from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import { Button } from 'components/Button';

const LoansAgreementModal = ({ isOpen, toggle, className, showCloseBtn, paddingTop, footerLink }) => (
  <Modal wrapClassName={className} isOpen={isOpen} toggle={toggle}>
    <ModalHeader className="no-border" toggle={toggle}>How will my payment be applied?</ModalHeader>
    <ModalBody className={`pt-${paddingTop} recurring-description`}>
      <p>Payments are applied to your account according to the terms of your Loan Agreement. Your Loan Agreement is located in the ‘Documents’ section of this Portal.</p>
      <p>It may take up to 2 business days to process your payment, however your account will be credited as if it had been received on the designated payment date.</p>
      <p>All times are Pacific Standard Time.</p>
      {showCloseBtn ? (
        <>
          <Button className="w-100" color="primary" onClick={toggle}>Close</Button>
          {footerLink}
        </>
      ) : null}
    </ModalBody>
  </Modal>
);

LoansAgreementModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  showCloseBtn: PropTypes.bool,
  paddingTop: PropTypes.number,
  footerLink: PropTypes.node,
};

LoansAgreementModal.defaultProps = {
  className: '',
  showCloseBtn: false,
  paddingTop: 3,
  footerLink: '',
};

export default LoansAgreementModal;
